import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import QuickChat from "../msg/QuickChat";
import FormatDecimal from "../../helpers/FormatDecimal";


import back from "../../back.png";


import { PieChart, Pie, Cell, BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer, } from 'recharts';



function KidInfo(props)
{

    const [p_dziecko_id, setPDzieckoId] = useState(props.p_dziecko_id);

    const [info,setInfo] = useState(null);



    const getInfo = () => {
       
 
        props.mainView.setProgress(-2);

       
        var req = {
            p_dziecko_id: p_dziecko_id
        }


        fetch( Config.url + '/rest_v1_rap,dz_info', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setInfo(res.result);                                                
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    if(info ==  null) 
    {
        setInfo([]);
        getInfo();
    }


    if(info == null || info.dziecko == undefined)
    {
        return <div>czekaj...</div>
    }


    var fData = new Array();

    fData = [
        {  nazwa: "Rozliczone",  wartosc: info.il_zaplaconych },
        {  nazwa: "Nierozliczone", wartosc: info.il_niezaplaconych },
    ];

 

    var pData = new Array();

    pData = [
        {  nazwa: "Rozliczone",  wartosc: info.p_il_zaplaconych },
        {  nazwa: "Nierozliczone", wartosc: info.p_il_niezaplaconych },
    ];



    const colors = ['#6aa44b', '#f25c37' ];
    const colors2 = ['#69b6bd', '#5482ac' ];


    var sumFDoZaplaty = 0.0;
    var sumFRozliczono = 0.0;

    var sumFODoZaplaty = 0.0;
    var sumFORozliczono = 0.0;

    var sumFPozostalo = 0.0;

    var sumPKwota = 0.0;
    var sumPRozliczono = 0.0;
    var sumPPozostalo = 0.0;

 


    return <div className="raports">       
       
                    {
                        (props.head == undefined || props.head == true) &&
                        <Fragment>
                                  <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>
                                    <br/>
                                    <br/>
                                    <div className="calColor">{info.dziecko.imie + " " +  info.dziecko.nazwisko} (dodany: {info.dziecko.utworzony})</div>
                                    <br/>
                        </Fragment>
                    }


            

                

                    <div><b>Saldo dziecka</b></div>
                    <table>
                            {
                             info.salda.map( (sub, sInx) => {
                                      
                                       

                                        return <tr>
                                            <td>{sub.nazwa}</td>
                                            <td className="goright"><FormatDecimal value={sub.saldo} /></td>
                                        </tr>
                                } )
                            }  

                                                      
                    </table>
                    <br/>

           

                   {
                       info.rodzice.length > 0 &&
                        <div className="rap_inline rap_half rap_small">
                             
                             <table className="">
                                <tr className="">
                                    <td colSpan={2}>
                                        <b>Opiekun / Rodzic</b>
                                        {
                                            info.rodzice[0].prowadzenie_salda == 1 &&
                                            <sup>&nbsp;odpowiedzialny za płatności</sup>
                                        }
                                    </td>                                    
                                </tr>
                                <tr>
                                    <td>Imię i nazwisko</td>
                                    <td className="gocenter">
                                        {  "[" + info.rodzice[0].id + "] " + info.rodzice[0].imie + " " + info.rodzice[0].nazwisko  }
                                        <QuickChat id={info.rodzice[0].id }  title={ info.rodzice[0].imie + " " + info.rodzice[0].nazwisko   } mainView={props.mainView} userData={props.userData} /> 
                                    </td>
                                </tr>
                                <tr>
                                    <td>E-mail</td>
                                    <td className="gocenter">{info.rodzice[0].e_mail   }</td>
                                </tr>
                                <tr>
                                    <td>Telefon</td>
                                    <td className="gocenter">{info.rodzice[0].telefon   }</td>
                                </tr>
                                {
                                    info.rodzice[0].salda.map( (itemX, is) => {
                                          
                                            return <tr>
                                                <td>{itemX.nazwa}</td>
                                                <td className="goright"><b><FormatDecimal value={itemX.saldo} /></b></td>
                                            </tr>  
                                    } )
                                }
                                
                             </table>

                        </div>
                   }
                       

                   {
                      info.rodzice.length > 1 &&
                      <div className="rap_inline rap_half rap_small">

                      {
                            info.rodzice[1] &&
                                    <table className="">
                                    <tr className="">
                                        <td colSpan={2}>
                                            <b>Opiekun / Rodzic</b>
                                            {
                                                info.rodzice[1].prowadzenie_salda == 1 &&
                                                <sup>odpowiedzialny za płatności</sup>
                                            }
                                        </td>                                    
                                    </tr>
                                    <tr>
                                        <td>Imię i nazwisko</td>
                                        <td>
                                            {   "[" + info.rodzice[1].id + "] " + info.rodzice[1].imie + " " + info.rodzice[1].nazwisko  }
                                            <QuickChat id={info.rodzice[1].id }  title={ info.rodzice[1].imie + " " + info.rodzice[1].nazwisko   } mainView={props.mainView} userData={props.userData} /> 
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>E-mail</td>
                                        <td>{info.rodzice[1].e_mail   }</td>
                                    </tr>
                                    <tr>
                                        <td>Telefon</td>
                                        <td>{info.rodzice[1].telefon   }</td>
                                    </tr>
                                    {
                                        info.rodzice[1].salda.map( (itemX, is) => {
                                                
                                                return <tr>
                                                    <td>{itemX.nazwa}</td>
                                                    <td><b><FormatDecimal value={itemX.saldo} /></b></td>
                                                </tr>  
                                        } )
                                    }
                                  
                                    </table>
                      }
                            
                     {
                         info.rodzice[1] == undefined &&
                        <table className="">
                        <tr className="">
                            <td colSpan={2}>
                                <b>Opiekun / Rodzic</b>                                            
                            </td>                                    
                        </tr>
                        <tr>
                        <td>Brak danych</td>
                        </tr>
                        </table>
                     }
                           

                    </div>
                   }
                    
                           

                      

                        

                    <div className="rap_inline rap_half rap_medium">
                                

                                    <b>Faktury, rozliczenia</b>   
                                    <ResponsiveContainer width="100%" height={300}>
                                        <PieChart width="100%" height="100%">
                                                    <Pie
                                                    data={fData}
                                                    dataKey="wartosc"
                                                    nameKey="nazwa"
                                                    cx="50%"
                                                    cy="50%"
                                                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                                    labelLine={false}
                                                    >
                                                    {
                                                        fData.map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                                                        ))
                                                    }
                                                    </Pie>
                                        </PieChart>
                                    </ResponsiveContainer>
 
                        </div>

                        <div className="rap_inline rap_half rap_medium">
                                <b>Przelewy, wpłaty i zwroty</b>   
                                <ResponsiveContainer width="100%" height={300}>
                                        <PieChart width="100%" height="100%">
                                                    <Pie
                                                    data={pData}
                                                    dataKey="wartosc"
                                                    nameKey="nazwa"
                                                    cx="50%"
                                                    cy="50%"
                                                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                                    labelLine={false}
                                                    >
                                                    {
                                                        fData.map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={colors2[index % colors2.length]} />
                                                        ))
                                                    }
                                                    </Pie>
                                        </PieChart>
                                    </ResponsiveContainer>
                        </div>

                        <br/>
                        <div>&nbsp;</div>
                        <br/>


                        <div className="calColor">Faktury, rozliczenia (do zapłaty: <FormatDecimal value={info.sum_do_zaplaty} />, rozliczono: <FormatDecimal value={info.sum_rozliczonych} />)</div>
                        <br/>
                                                        

                        <table className="table" >
                                         <thead>
                                            <tr className="header">                                         
                                                <td className="td_left">LP</td>
                                                <td>Numer</td>  
                                                <td>Data wystawienia</td>  
                                                <td>Do zapłaty</td>    
                                                <td>Kwota rozliczenia</td>                                                                                                                                                                                
                                                <td>Kwota ods.</td>                                                                                                                                                                                
                                                <td>Kwota roz. ods.</td>                                                                                                                                                                                
                                                <td className="td_right">Pozostało</td>                                                                                                                                                                                
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                info.faktury.map(  (row,ix) => {

                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    sumFDoZaplaty = parseFloat(sumFDoZaplaty) + parseFloat(row.do_zaplaty);
                                                    sumFRozliczono = parseFloat(sumFRozliczono) + parseFloat(row.kwota_rozliczenia);
                                                     
                                                    sumFODoZaplaty = parseFloat(sumFODoZaplaty) + parseFloat(row.kwota_odsetek);
                                                    sumFORozliczono = parseFloat(sumFORozliczono) + parseFloat(row.kwota_rozliczenia_odsetek);

                                                    sumFPozostalo = parseFloat(sumFPozostalo) + parseFloat(row.pozostalo);

                                                    return  <tr className={ rowStyle }>                                         

                                                        <td className="td_left gocenter">{ix+1}</td>
                                                        <td className="goleft">{row.numer}</td>  
                                                        <td className="gocenter">{row.data_wystawienia}</td>  
                                                        <td className="goright"><FormatDecimal value={row.do_zaplaty} /> </td>    
                                                        <td className="goright"><FormatDecimal value={row.kwota_rozliczenia} /> </td>                                                                                                                                                                                 

                                                        <td className="goright"><FormatDecimal value={row.kwota_odsetek} /> </td>                                                                                                                                                                                 
                                                        <td className="goright"><FormatDecimal value={row.kwota_rozliczenia_odsetek} /> </td>                                                                                                                                                                                 

                                                        <td className="goright"><FormatDecimal value={row.pozostalo} /> </td>                                                                                                                                                                                 
                                                        
                                                    </tr>

                                                } )
                                            }

                                                    <tr>                                         
                                                        <td className="td_left gocenter"> </td>
                                                        <td className="goleft"> </td>  
                                                        <td className="gocenter"> </td>  
                                                        <td className="goright gobold"><FormatDecimal value={sumFDoZaplaty} /> </td>    
                                                        <td className="goright gobold"><FormatDecimal value={sumFRozliczono} /> </td>                                                                                                                                                                                 

                                                        <td className="goright gobold"><FormatDecimal value={sumFODoZaplaty} /> </td>    
                                                        <td className="goright gobold"><FormatDecimal value={sumFORozliczono} /> </td>                                                                                                                                                                                

                                                        <td className="goright gobold"><FormatDecimal value={sumFPozostalo} /> </td>                                                                                                                                                                                 
                                                    </tr>

                                        </tbody>
                        </table>

                        <br/>
                        <div className="calColor">Przelewy, wpłaty, zwroty (łącznie: <FormatDecimal value={info.p_sum_kwota} />, rozliczono: <FormatDecimal value={info.p_sum_kwota_roz} />)</div>
                        <br/>

                        
                        <table className="table" >
                                         <thead>
                                            <tr className="header">                                         
                                                <td className="td_left">LP</td>
                                                <td>Data</td>  
                                                <td>Tytuł</td>  
                                                <td>Kwota</td>    
                                                <td>Kwota rozliczenia</td>                                   
                                                <td className="td_right">Pozostało</td>                                   
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                info.przelewy.map(  (row,ix) => {

                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    sumPKwota = parseFloat(sumPKwota) + parseFloat(row.kwota);
                                                    sumPRozliczono = parseFloat(sumPRozliczono) + parseFloat(row.kwota_rozliczenia);
                                                    sumPPozostalo = parseFloat(sumPPozostalo) + parseFloat(row.pozostalo);

                                                    return  <tr className={ rowStyle }>                                         
                                                        <td className="td_left gocenter">{ix+1}</td>
                                                        <td className="gocenter">{row.data}</td>  
                                                        <td className="goleft">{row.tytul}</td>  
                                                        <td className="goright"><FormatDecimal value={row.kwota} /> </td>    
                                                        <td className="goright"><FormatDecimal value={row.kwota_rozliczenia} /> </td>                                                                                                                                                                                 
                                                        <td className="goright"><FormatDecimal value={row.pozostalo} /> </td>                                                                                                                                                                                 
                                                    </tr>

                                                } )
                                            }  

                                                    <tr>                                         
                                                        <td className="td_left gocenter"> </td>
                                                        <td className="gocenter"> </td>  
                                                        <td className="goleft"> </td>  
                                                        <td className="goright gobold"><FormatDecimal value={sumPKwota} /> </td>    
                                                        <td className="goright gobold"><FormatDecimal value={sumPRozliczono} /> </td>                                                                                                                                                                                 
                                                        <td className="goright gobold"><FormatDecimal value={sumPPozostalo} /> </td>                                                                                                                                                                                 
                                                    </tr>

                                        </tbody>
                        </table>
 
    </div>
}


export default KidInfo;